import { useState } from "react";

import { Client } from "~/types/client";

export const useClientSort = (clients: Client[]) => {
  const [sortField, setSortField] = useState("company");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

  // Handle sort change
  const handleSort = (field: string) => {
    if (field === sortField) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  // Sort clients
  const sortedClients = [...clients].sort((a, b) => {
    const fieldA = a[sortField as keyof typeof a];
    const fieldB = b[sortField as keyof typeof b];

    if (typeof fieldA === "string" && typeof fieldB === "string") {
      return sortDirection === "asc"
        ? fieldA.localeCompare(fieldB)
        : fieldB.localeCompare(fieldA);
    }

    if (typeof fieldA === "number" && typeof fieldB === "number") {
      return sortDirection === "asc" ? fieldA - fieldB : fieldB - fieldA;
    }

    return 0;
  });

  return {
    sortField,
    sortDirection,
    handleSort,
    sortedClients,
  };
};
